import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=97653bea&scoped=true&"
import script from "./ArticleListItem.vue?vue&type=script&lang=js&"
export * from "./ArticleListItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListItem.vue?vue&type=style&index=0&id=97653bea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97653bea",
  null
  
)

export default component.exports